
































import { defineComponent, watch } from '@vue/composition-api';
import { InformModel, InitPageNum } from './model';
import { useApolloModel } from 'vue-apollo-model';
import xss from '@kwaisec/kwai-js-xss';
import { format } from 'date-fns';
import PageFooter from '@/components/page-footer/index.vue';

export default defineComponent({
    components: { PageFooter },
    setup(props, context) {
        const model = useApolloModel(InformModel);
        function goBack() {
            context.root.$router.push({
                path: '/platform/inform/list',
                query: {
                    pageNum: context.root.$route.query.from || InitPageNum,
                },
            });
        }
        watch(
            () => model.isDetailError,
            (v) => {
                if (v) {
                    goBack();
                }
            },
        );
        return {
            model,
            format,
            goBack,
            xss,
        };
    },
});
